// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
      suggestionMobileStyle: 'style3',
	}
};
//Set theme search mode to product only
window.theme.searchMode = 'product';

(function() {
	BoostPFS.inject(this);
  
    InstantSearchResult.prototype._applyFilterAutocompleteAppendElement = function() {
      if(this.searchInputId == 'boost-pfs-search-box-2'){
        this.appendToSelector = 'div.boost-pfs-filter-collection-header-wrapper form.boost-pfs-search-form';
      }      
    };
  
	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};
  
//     SearchInput.prototype.onCloseAutocomplete = function(event) {
//       $('.boost-pfs-search-suggestion-popover').css('display','none');

//       if($('html').hasClass('no-scroll')){
//         $('html').removeClass('no-scroll');
//         console.log('no')
//       }
//     };
//     SearchInput.prototype._onFocusSearchBox = function(event) {
//       $('html').addClass('no-scroll');
//     };


  
    SearchInput.prototype.afterBindEvents = function() {
      // Fix cannot redirect to search page when pressing enter
      jQ('.boost-pfs-search-box').on('keypress', function(event) {	
        if (event.keyCode == 13) {	
          jQ(this).parents('form').submit();	
        }
        
        if($('#boost-pfs-search-suggestion-1 .boost-pfs-search-suggestion-group[data-group="products"]').length > 0){
          $('.boost-pfs-search-suggestion-wrapper').addClass('hide');
        }        
      })
    };
  
    SearchInput.prototype._onTypeSearchBoxEvent = function(event) {
      Globals.currentTerm = event.target.value;

      if(Globals.currentTerm == ''){
        $('.boost-pfs-search-suggestion-wrapper').removeClass('hide');      	
      }
    }

InstantSearchApi.beforeCall = function(searchTerm) {
    /* Change the params before calling api */
    var newSearchTerm = searchTerm.replace(/s+/g,'');
    Globals.instantSearchQueryParams['q'] = newSearchTerm;
}
    
})();